import PageLayout from "./components/PageLayout";

function Contact() {
  return (
    <PageLayout
      title="Contact"
      subtitle="Have questions, feedback, bugs, or feature ideas? Reach out anytime."
      maxWidth="600px"
    >
      <div style={cardStyle}>
        <a
          href="mailto:mybuildid@gmail.com"
          style={buttonStyle}
        >
          Email: mybuildid@gmail.com
        </a>

        <a
          href="https://www.instagram.com/mybuildid"
          target="_blank"
          rel="noreferrer"
          style={secondaryButtonStyle}
        >
          Follow us on Instagram @mybuildid
        </a>
      </div>
    </PageLayout>
  );
}

const cardStyle = {
  backgroundColor: "#181818",
  border: "1px solid #242424",
  borderRadius: "20px",
  padding: "28px",
  display: "flex",
  flexDirection: "column",
  gap: "14px",
};

const buttonStyle = {
  backgroundColor: "#e10600",
  color: "white",
  padding: "14px",
  borderRadius: "12px",
  textDecoration: "none",
  fontWeight: "bold",
  textAlign: "center",
};

const secondaryButtonStyle = {
  ...buttonStyle,
  backgroundColor: "#222",
  border: "1px solid #333",
};

export default Contact;